export function sortArraysInObject<T>(
	record: Record<string, T[]>,
	sortFunction?: (a: T, b: T) => number,
): Record<string, T[]> {
	for (const key in record) {
		if (Array.isArray(record[key])) {
			record[key].sort(sortFunction); // Sorts alphabetically or numerically by default
		}
	}

	return record;
}
